/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VisibilityBoardAddressRow_rowData$ref = any;
export type VisibilityBoardAddressInput = {|
  address: string,
  description: string,
  visibilityBoardId: any,
|};
export type visibilityBoardAddress_addVisibilityBoardAddressEntry_MutationVariables = {|
  visibilityBoardAddressInput: VisibilityBoardAddressInput
|};
export type visibilityBoardAddress_addVisibilityBoardAddressEntry_MutationResponse = {|
  +visibilityBoardAddressMutation: ?{|
    +addVisibilityBoardAddressEntry: ?{|
      +$fragmentRefs: VisibilityBoardAddressRow_rowData$ref
    |}
  |}
|};
export type visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation = {|
  variables: visibilityBoardAddress_addVisibilityBoardAddressEntry_MutationVariables,
  response: visibilityBoardAddress_addVisibilityBoardAddressEntry_MutationResponse,
|};
*/


/*
mutation visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation(
  $visibilityBoardAddressInput: VisibilityBoardAddressInput!
) {
  visibilityBoardAddressMutation {
    addVisibilityBoardAddressEntry(visibilityBoardAddressInput: $visibilityBoardAddressInput) {
      ...VisibilityBoardAddressRow_rowData
      id
    }
  }
}

fragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {
  id
  address
  description
  visibilityBoard {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibilityBoardAddressInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "visibilityBoardAddressInput",
    "variableName": "visibilityBoardAddressInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddressMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardAddressMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoardAddress",
            "kind": "LinkedField",
            "name": "addVisibilityBoardAddressEntry",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VisibilityBoardAddressRow_rowData"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddressMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardAddressMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoardAddress",
            "kind": "LinkedField",
            "name": "addVisibilityBoardAddressEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VisibilityBoard",
                "kind": "LinkedField",
                "name": "visibilityBoard",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b3b2a47e6c206d287cca17f3bb838d43",
    "id": null,
    "metadata": {},
    "name": "visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation",
    "operationKind": "mutation",
    "text": "mutation visibilityBoardAddress_addVisibilityBoardAddressEntry_Mutation(\n  $visibilityBoardAddressInput: VisibilityBoardAddressInput!\n) {\n  visibilityBoardAddressMutation {\n    addVisibilityBoardAddressEntry(visibilityBoardAddressInput: $visibilityBoardAddressInput) {\n      ...VisibilityBoardAddressRow_rowData\n      id\n    }\n  }\n}\n\nfragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {\n  id\n  address\n  description\n  visibilityBoard {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '757c8a275800c8bdf93557969610cb96';

module.exports = node;
